import { z } from 'zod';

/** Read-only company profile surfaced on the Setup → Company page. */
export const CompanySchema = z.object({
  name: z.string(),
  domains: z.array(z.string()),
});
export type Company = z.infer<typeof CompanySchema>;
